import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Vendors from './pages/Vendors';
import Apps from './pages/Apps';
import FAQs from './pages/FAQs';
import Privacy from './pages/Privacy';
import ToS from './pages/ToS';
import CSAE from './pages/CSAE';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/vendors" element={<Vendors />} />
            <Route path="/apps" element={<Apps />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/tos" element={<ToS />} />
            <Route path="/csae" element={<CSAE />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
